import React, { Component } from 'react';
import { NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import { LoadPanel } from 'devextreme-react/load-panel';
import { SelectBox } from 'devextreme-react/select-box';
import jsSHA from "jssha"; // npm install jssha
import DatePicker from "react-datepicker"; // npm install react - datepicker --save
import NumberFormat from 'react-number-format';
import Swal from 'sweetalert2';
import { CardTypes } from '../../helpers/fixcodes.js';
import { getRequestParams } from '../../helpers/globalfunctions.js';
const customStyles = {
    content: {
        width: '50%'
    }
};
const position = { of: '#confirmdiv' };
const $ = window.$;
let currentTime = new Date();
export class QuotationConfirmationComponent extends Component {
    static displayName = QuotationConfirmationComponent.name;

    constructor(props) {
        currentTime = new Date();
        super(props);
        const queryString = require('query-string');
        var parsed = queryString.parse(this.props.location.search);
        const newreservationId = parsed.reservationId;
        const transaction = parsed.transaction;
        this.state = {
            newreservationId: newreservationId,
            transactionId: transaction,
            isSubmited: false,
            loadPanelVisible: false,
            quoteId: parsed.quoteId,
            paxFirstName: "",
            paxLastName: "",
            cellCountryCode: "",
            mobileNo: "",
            email: "",
            pickupLocation: "",
            pickupAddress: "",
            dropoffLocation: "",
            dropoffAddress: "",
            puDateTime: "",
            vehicleType: "",
            noOfPax: "",
            totalFare: "",

            dropdownPaymentType: [],
            paymentTypeId: 1,
            dropdownVoucherCompany: [],
            voucherCompanyId: 0,
            paymentTermId: "1",
            existingCardId: 0,
            cardExpiry: "",
            cardType: "",
            cardImage: 'data:image/svg+xml;base64,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',
            creditCard: "",
            checkNumber: "",
            checkDate: "",
            checkBank: "",
            chargeTo: "",
            voucherCode: "",

            tripDetails: null,
            chkPaymentGatewaySelection: "1",
            errors: {
                paymentTypeId: "",
                paidAmount: "",
                checkNumber: "",
                checkDate: "",
                checkBank: "",
                existingCardId: "",
                creditCard: "",
                cardType: "",
                cardExpiry: "",
                voucherCompanyId: "",
                voucherCode: "",

            }


        };
        this.getPaymentType = this.getPaymentType.bind(this);
        this.getVoucherCompany = this.getVoucherCompany.bind(this);
        this.getGetQuoteDetails = this.getGetQuoteDetails.bind(this);
        this.handlePaymentTypeChange = this.handlePaymentTypeChange.bind(this);
        this.handlePaymentGatewaySelectionChange = this.handlePaymentGatewaySelectionChange.bind(this);
        this.handleVoucherCompanyChange = this.handleVoucherCompanyChange.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleConfirmQuotation = this.handleConfirmQuotation.bind(this);
        this.cardExpiry = this.cardExpiry.bind(this);
        this.limitMonthCreditCard = this.limitMonthCreditCard.bind(this);
        this.limitYearCreditCard = this.limitYearCreditCard.bind(this);

        if (this.state.transactionId != null) {
            let strAlert = "";
            strAlert = "Your quote confirmed successfully. confirmation number is: <br><br>";
            strAlert += "\t" + this.state.newreservationId + "<br>";
            strAlert += "<br> Thank you for booking.";
            Swal.fire({
                icon: 'success',
                title: 'success',
                html: strAlert,
                width: "25%",
                allowOutsideClick: false
            }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                    window.history.pushState({}, null, '/');
                }
            })
        }
    }

    async getPaymentType() {
        try {
            const requestParams = getRequestParams('GET', '');
            const response = await fetch('external-api/paymenttype-dropdownlist', requestParams);
            const data = await response.json();

            this.setState({
                dropdownPaymentType: data.paymentType
            });
        } catch (e) {
            console.log(e);
        }
    }

    async getVoucherCompany() {

        try {
            const requestParams = getRequestParams('GET', '');
            const response = await fetch('external-api/voucher-customer-dropdown/', requestParams);
            const data = await response.json();
            this.setState({
                dropdownVoucherCompany: data.customers
            });
        } catch (e) {
            console.log(e);
        }
    }

    async getGetQuoteDetails() {

        try {
            var newObject = new Object();
            newObject.QuatationId = 0;
            newObject.QuoteStatusId = "";

            const requestParams = getRequestParams('POST', newObject);
            const response = await fetch('external-api/quote-details/' + parseInt(this.state.quoteId) + '/list/', requestParams);
            const data = await response.json();
            this.setState({
                tripDetails: data.quoteDetails[0],
            });
        } catch (e) {
            console.log(e);
        }
    }

    handlePaymentTypeChange(selectedOption) {
        this.setState({ paymentTypeId: (selectedOption.selectedItem != null ? selectedOption.selectedItem.id : 0), })

        this.setState({
            checkNumber: "",
            checkDate: "",
            checkBank: "",
            existingCardId: 0,
            creditCard: "",
            cardType: "",
            cardExpiry: "",
            voucherCompanyId: 0,
            voucherCode: "",
            chkPaymentGatewaySelection: "1",
        });
        this.state.errors["checkNumber"] = "";
        this.state.errors["checkBank"] = "";
        this.state.errors["checkDate"] = "";
        this.state.errors["existingCardId"] = "";
        this.state.errors["creditCard"] = "";
        this.state.errors["cardType"] = "";
        this.state.errors["cardExpiry"] = "";
        this.state.errors["voucherCompanyId"] = "";
        this.state.errors["voucherCode"] = "";

        var paytypeId = (selectedOption.selectedItem != null ? selectedOption.selectedItem.id : 0);
        if (parseInt(this.state.chkPaymentGatewaySelection) == 2) {
            if (paytypeId === 2 || paytypeId === 3) {
                this.setState({ paidAmount: parseFloat(this.state.totalFare).toFixed(3), paymentTermId: "1" });
            } else {
                this.setState({ paidAmount: parseFloat(0).toFixed(3), paymentTermId: "1" });
            }
        } else {
            if (paytypeId === 2) {
                this.setState({ paidAmount: parseFloat(this.state.totalFare).toFixed(3), paymentTermId: "1" });
            } else {
                this.setState({ paidAmount: parseFloat(0).toFixed(3), paymentTermId: "1" });
            }
        }

    }

    handlePaymentGatewaySelectionChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({ chkPaymentGatewaySelection: value });

        this.setState({
            checkNumber: "",
            checkDate: "",
            checkBank: "",
            existingCardId: 0,
            creditCard: "",
            cardType: "",
            cardExpiry: "",
            voucherCompanyId: 0,
            voucherCode: "",
        });
        this.state.errors["checkNumber"] = "";
        this.state.errors["checkBank"] = "";
        this.state.errors["checkDate"] = "";
        this.state.errors["existingCardId"] = "";
        this.state.errors["creditCard"] = "";
        this.state.errors["cardType"] = "";
        this.state.errors["cardExpiry"] = "";
        this.state.errors["voucherCompanyId"] = "";
        this.state.errors["voucherCode"] = "";
    }

    handleVoucherCompanyChange(selectedOption) {
        this.setState({ voucherCompanyId: (selectedOption.selectedItem != null ? selectedOption.selectedItem.id : 0), })
        this.state.errors["voucherCompanyId"] = "";
    }

    async componentDidMount() {

        this.setState({
            loadPanelVisible: true,
        });

        await this.getPaymentType();
        await this.getVoucherCompany();
        await this.getGetQuoteDetails();
        if (this.state.tripDetails != null) {

            this.setState({
                paxFirstName: this.state.tripDetails.firstName,
                paxLastName: this.state.tripDetails.lastName,
                cellCountryCode: this.state.tripDetails.cellCountryCode,
                mobileNo: this.state.tripDetails.mobileNo,
                email: this.state.tripDetails.email,
                pickupLocation: this.state.tripDetails.puLocationName,
                pickupAddress: this.state.tripDetails.puAddress,
                dropoffLocation: this.state.tripDetails.doLocationName,
                dropoffAddress: this.state.tripDetails.doAddress,
                puDateTime: new Date(this.state.tripDetails.puDateTime).toLocaleDateString() + " " + new Date(this.state.tripDetails.puDateTime).toLocaleTimeString(),

                vehicleType: this.state.tripDetails.vehicleType,
                noOfPax: this.state.tripDetails.adultNo,
                totalFare: parseFloat(this.state.tripDetails.totalFare).toFixed(3),
            });
        }
        var selectedOption = new Object();
        selectedOption.selectedItem = new Object();
        selectedOption.selectedItem.id = 2;
        this.handlePaymentTypeChange(selectedOption);

        this.setState({
            loadPanelVisible: false,
        });
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        if (name === "creditCard") {
        
            const re = /^[0-9\b]+$/;
            CardTypes.forEach((item) => {
                if (event.target.value.trim().match(item.pattern)) {
                    this.setState({ cardType: item.name, cardImage: item.image })
                }
            })

            this.setState({ creditCard: event.target.value })
            if (event.target.value === "") {
                this.setState({ cardType: "", cardImage: "" })
            }
            this.state.errors["cardType"] = "";
        } else if (name === "checkNumber") {
            const re = /^[0-9\b]+$/;
            if (event.target.value === '' || re.test(event.target.value)) {
                this.setState({ checkNumber: event.target.value })
                this.state.errors["checkNumber"] = "";
            }
        } else {
            this.setState({
                [name]: value
            });
            this.state.errors[name] = "";
        }
    }

    handleValidation() {
        let errors = this.state.errors;
        let formIsValid = true;
        errors.paymentTypeId = "";
        errors.paidAmount = "";
        errors.checkNumber = "";
        errors.checkBank = "";
        errors.checkDate = "";
        errors.creditCard = "";
        errors.cardType = "";
        errors.cardExpiry = "";
        errors.voucherCompanyId = "";
        errors.voucherCode = "";


        if (this.state.paymentTypeId === 0) {
            formIsValid = false;
            errors.paymentTypeId = "Please select payment type.";
        }

        if (parseInt(this.state.chkPaymentGatewaySelection) == 2 && this.state.paymentTypeId === 2) {
            if (this.state.creditCard.trim() === "") {
                formIsValid = false;
                errors.creditCard = "Please select or enter card.";
            }

            if (this.state.cardType === "") {
                formIsValid = false;
                errors.cardType = "Please select card type.";
            }

            if (this.state.cardExpiry === "") {
                formIsValid = false;
                errors.cardExpiry = "Please enter card expiry.";
            }
        }

        if (this.state.paymentTypeId === 4) {
            if (this.state.checkNumber === "") {
                formIsValid = false;
                errors.checkNumber = "Please enter check number.";
            }

            if (this.state.checkBank === "") {
                formIsValid = false;
                errors.checkBank = "Please enter bank name.";
            }

            if (this.state.checkDate === "") {
                formIsValid = false;
                errors.checkDate = "Please enter check date.";
            }
        }

        if (this.state.paymentTypeId === 7) {
            if (this.state.voucherCompanyId === 0) {
                formIsValid = false;
                errors.voucherCompanyId = "Please select company.";
            }

            if (this.state.voucherCode === "") {
                formIsValid = false;
                errors.voucherCode = "Please enter voucher.";
            }
        }

        if (parseInt(this.state.paymentTypeId) === 2 || parseInt(this.state.paymentTypeId) === 3) {
            if (parseFloat(this.state.paidAmount) === 0) {
                formIsValid = false;
                errors.paidAmount = "Please enter paid amt.";
            }
        }

        this.setState({ errors: errors });
        return formIsValid;
    }

    async askConfirmQuoteConfirm() {
        let isResult = false;
        await Swal.fire({
            title: "<small>Are you sure</small>",
            html: "You are going to confirm this Quote!<br> Do you want to still continue?",
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Continue',
            cancelButtonText: 'Close',
            allowOutsideClick: false
        }).then((result) => {
            if (result.isConfirmed) {
                isResult = true;
            }
        })
        return isResult;
    }

    async handleConfirmQuotation(e) {
        e.preventDefault();
        if (this.handleValidation()) {

            if (parseInt(this.state.paymentTermId) == 2) {

                if (this.state.paymentTypeId !== 2 && this.state.paymentTypeId !== 3) {
                    const isValid = await Swal.fire({
                        title: "<small>Payment Type</small>",
                        text: "Please select payment type Credit Card Or Cash for partial payment!",
                        icon: "info",
                        width: "25%",
                        dangerMode: false,
                        allowOutsideClick: false
                    });
                    return;
                } else if (parseFloat(this.state.paidAmount) > parseFloat(this.state.totalFare)) {
                    const isValid = await Swal.fire({
                        title: "<small>Payment Type</small>",
                        text: "Please enter paid amount less than total fare for partial payment!",
                        icon: "info",
                        width: "25%",
                        dangerMode: false,
                        allowOutsideClick: false
                    });
                    return;
                } else if (parseFloat(this.state.paidAmount) < 0) {
                    const isValid = await Swal.fire({
                        title: "<small>Payment Type</small>",
                        text: "Please enter paid amount less than total fare for partial payment!",
                        icon: "info",
                        width: "25%",
                        dangerMode: false,
                        allowOutsideClick: false
                    });
                    return;
                } else if (parseFloat(this.state.paidAmount) == parseFloat(this.state.totalFare)) {
                    const isValid = await Swal.fire({
                        title: "<small>Payment Type</small>",
                        html: "Full paid amount is not allowed under partial payment section.<Br>Please select 'Paid In Full' option under payment term!",
                        icon: "info",
                        width: "25%",
                        dangerMode: false,
                        allowOutsideClick: false
                    });
                    return;
                }

            } else {
                if (this.state.paymentTypeId === 2 || this.state.paymentTypeId === 3) {
                    if (parseFloat(this.state.paidAmount) > parseFloat(this.state.totalFare)) {
                        const isValid = await Swal.fire({
                            title: "<small>Payment Type</small>",
                            text: "Please enter paid amount equal to total fare for full payment!",
                            icon: "info",
                            width: "25%",
                            dangerMode: false,
                            allowOutsideClick: false
                        });
                        return;
                    } else if (parseFloat(this.state.paidAmount) < 0) {
                        const isValid = await Swal.fire({
                            title: "<small>Payment Type</small>",
                            text: "Please enter paid amount equal to total fare for full payment!",
                            icon: "info",
                            width: "25%",
                            dangerMode: false,
                            allowOutsideClick: false
                        });
                        return;
                    }
                }
            }




            const isConfirm = await this.askConfirmQuoteConfirm();
            if (!isConfirm) {
                return;
            } else {
                try {
                    var newObject = new Object();
                    newObject.quotationId = this.state.quoteId <= 0 ? 0 : this.state.tripDetails.quotationId;
                    newObject.quoteId = parseInt(this.state.quoteId);
                    newObject.paymentTypeId = parseInt(this.state.paymentTypeId);
                    newObject.paymentGatewayId = parseInt(this.state.chkPaymentGatewaySelection);
                    newObject.partialPay = parseInt(this.state.paymentTermId) === 1 ? false : true;

                    newObject.voucherNo = parseInt(this.state.paymentTypeId) == 7 ? this.state.voucherCode : "";
                    newObject.voucherCompany = parseInt(this.state.paymentTypeId) == 7 ? parseInt(this.state.voucherCompanyId) : 0;
                    newObject.chqBankName = this.state.checkBank;
                    newObject.chqNumber = this.state.checkNumber;
                    newObject.chqDate = this.state.checkDate;

                    newObject.creditCardNumber = (parseInt(this.state.chkPaymentGatewaySelection) == 2 && parseInt(this.state.paymentTypeId) == 2) ? this.state.creditCard : "";
                    newObject.creditCardExpiry = (parseInt(this.state.chkPaymentGatewaySelection) == 2 && parseInt(this.state.paymentTypeId) == 2) ? this.state.cardExpiry : "";
                    newObject.cardType = (parseInt(this.state.chkPaymentGatewaySelection) == 2 && parseInt(this.state.paymentTypeId) == 2) ? this.state.cardType : "";
                    if (parseInt(this.state.chkPaymentGatewaySelection) == 2) {
                        if (newObject.partialPay == false) {
                            if (newObject.paymentTypeId == 2 || newObject.paymentTypeId == 3) {
                                newObject.billableFare = parseFloat(0);
                                newObject.totalPaid = parseFloat(this.state.paidAmount);
                            } else {
                                newObject.billableFare = parseFloat(this.state.totalFare);
                                newObject.totalPaid = 0.00;
                            }
                        } else {
                            if (newObject.paymentTypeId == 2 || newObject.paymentTypeId == 3) {
                                newObject.billableFare = parseFloat(this.state.totalFare) - parseFloat(this.state.paidAmount);
                                newObject.totalPaid = parseFloat(this.state.paidAmount);
                            }
                        }
                    } else {
                        if (newObject.partialPay == false) {
                            if (newObject.paymentTypeId == 2) {
                                newObject.billableFare = parseFloat(0);
                                newObject.totalPaid = parseFloat(this.state.paidAmount);
                            } else {
                                newObject.billableFare = parseFloat(this.state.totalFare);
                                newObject.totalPaid = 0.00;
                            }
                        } else {
                            if (newObject.paymentTypeId == 2) {
                                newObject.billableFare = parseFloat(this.state.totalFare) - parseFloat(this.state.paidAmount);
                                newObject.totalPaid = parseFloat(this.state.paidAmount);
                            }
                        }
                    }
                    newObject.statusId = 318;
                    newObject.historyLog = "Quote confirmed by unauthenticated user.";
                    this.setState({ isSubmited: true });
                    const requestParams = getRequestParams('POST', newObject);
                    const response = await fetch('external-api/confirm-quote', requestParams);
                    const data = await response.json();

                    if (data.isSuccess == true && parseInt(this.state.chkPaymentGatewaySelection) == 1 && this.state.paymentTypeId === 2) {

                        var sumAmount = 0;
                        var _orderDetails = '';
                        for (var i = 0; i < data.tripResult.length; i++) {
                            sumAmount = sumAmount + parseFloat(data.tripResult[i].tripFare);

                            if (_orderDetails == '') {
                                _orderDetails = data.tripResult[i].tripId.toString() + '_' + parseFloat(data.tripResult[i].tripFare).toFixed(2) + ",";
                            } else {
                                _orderDetails = _orderDetails + data.tripResult[i].tripId.toString() + '_' + parseFloat(data.tripResult[i].tripFare).toFixed(2) + ",";
                            }
                        }

                        _orderDetails = _orderDetails.replace(/,\s*$/, "");
                        var CreateTransactionRequest = new Object();
                        CreateTransactionRequest.TransactionSource = "UTWiz Confirm Quote By Unauthenticated User";
                        CreateTransactionRequest.AccountId = Number(sessionStorage.getItem("session_accountId"));
                        CreateTransactionRequest.LocationId = Number(sessionStorage.getItem("session_locationId"));
                        CreateTransactionRequest.RideId = data.tripResult.length == 1 ? data.tripResult[0].tripId : 0;
                        CreateTransactionRequest.ReservationId = Number(data.reservationId);
                        CreateTransactionRequest.FirstName = this.state.paxFirstName;
                        CreateTransactionRequest.LastName = this.state.paxLastName;
                        CreateTransactionRequest.EmailId = this.state.email;
                        CreateTransactionRequest.PhoneNo = this.state.mobileNo;
                        CreateTransactionRequest.Amount = parseFloat(parseFloat(sumAmount).toFixed(2));
                        CreateTransactionRequest.OrderDetails = _orderDetails;
                        CreateTransactionRequest.PlanId = 0;
                        CreateTransactionRequest.CustomerId = 0;
                        CreateTransactionRequest.InvoiceReceiptNo = parseInt(this.state.quoteId);
                        const transactionRequestParams = getRequestParams('POST', CreateTransactionRequest);
                        const transactionResponse = await fetch('payment-gateway-api/' + this.state.chkPaymentGatewaySelection + '/transaction', transactionRequestParams);
                        const transactionData = await transactionResponse.json();

                        let paymentUrl = "", paymentKey = "", paymentSalt = "", txnId = "";
                        if (transactionData.transactionId != null && transactionData.settings.length >= 3) {
                            txnId = transactionData.transactionId;
                            paymentUrl = transactionData.settings[0].settingValue;
                            paymentKey = transactionData.settings[1].settingValue;
                            paymentSalt = transactionData.settings[2].settingValue;
                            let dataStr = paymentKey + "|" + txnId + "|" + CreateTransactionRequest.Amount + "|" + "UTWiz RIDE" + "|" + this.state.paxFirstName + "|" + this.state.email + "|" + CreateTransactionRequest.TransactionSource + "|" + CreateTransactionRequest.OrderDetails + "|||||||||" + paymentSalt;

                            let hashObj = new jsSHA("SHA-512", "TEXT", { numRounds: parseInt(1, 10) });
                            hashObj.update(dataStr);
                            let hashValue = hashObj.getHash("HEX");
                            let paymentAppUrl = data.paymentAppUrl;
                            let postForm = '<form action="' + paymentUrl + '" method="post" id="frmPay">';
                            postForm += '<input type="hidden" id="key" name="key" value="' + paymentKey + '" />';
                            postForm += '<input type="hidden" name="salt" value="' + paymentSalt + '" />';
                            postForm += '<input type="hidden" id="firstname" name="firstname" value="' + this.state.paxFirstName + '" />';
                            postForm += '<input type="hidden" id="lastname" name="lastname" value="' + this.state.paxLastName + '" />';
                            postForm += '<input type="hidden" id="surl" name="surl" value="' + paymentAppUrl + 'PayUMoney/TrnxSuccess" />';
                            postForm += '<input type="hidden" id="phone" name="phone" value="' + this.state.mobileNumber + '" />';
                            postForm += '<input type="hidden" id="hash" name="hash" value="' + hashValue + '" />';
                            postForm += '<input type="hidden" id="curl" name="curl" value="' + paymentAppUrl + 'PayUMoney/TrnxCancelledByUser" />';
                            postForm += '<input type="hidden" id="furl" name="furl" value="' + paymentAppUrl + 'PayUMoney/TrnxFailed" />';
                            postForm += '<input type="hidden" id="txnid" name="txnid" value="' + txnId + '" />';
                            postForm += '<input type="hidden" id="productinfo" name="productinfo" value="UTWiz RIDE" />';
                            postForm += '<input type="hidden" id="amount" name="amount" value="' + CreateTransactionRequest.Amount + '" />';
                            postForm += '<input type="hidden" id="udf1" name="udf1" value="' + CreateTransactionRequest.TransactionSource + '" />';
                            postForm += '<input type="hidden" id="udf2" name="udf2" value="' + CreateTransactionRequest.OrderDetails + '" />';
                            postForm += '<input type="hidden" id="email" name="email" value="' + this.state.email + '" />';
                            postForm += '<input type="submit" value="submit">';
                            postForm += '</form>';
                            $(postForm).appendTo('body').submit();
                        }

                    } else {
                        let strAlert = "";

                        if (!data.isSuccess) {
                            if (data.retValue == -2000) {
                                strAlert = "Quatation confirmation failed due to " + data.resultMessage;
                            } else {
                                strAlert = "Quatation confirmation failed due to server error.";
                            }
                        } else {
                            strAlert = "Your quote confirmed successfully. confirmation number is: <br><br>";
                            strAlert += "\t" + data.reservationId + "<br>";
                            strAlert += "<br> Thank you for booking.";
                        }

                        Swal.fire({
                            icon: data.isSuccess ? 'success' : 'error',
                            title: data.isSuccess ? 'Success' : 'Oops...',
                            html: strAlert,
                            width: "30%",
                            allowOutsideClick: false
                        }).then((result) => {
                            /* Read more about isConfirmed, isDenied below */
                            if (data.isSuccess) {
                                if (result.isConfirmed) {
                                    this.setState({ isSubmited: false });
                                    this.closeModal();
                                }
                            } else {
                                this.setState({ isSubmited: false });
                            }
                        })
                    }
                } catch (e) {
                    console.log(e);
                }
            }
        }
    }

    limitYearCreditCard(val, min) {
        if (val.length === 1 && val[0] < min[0]) {
            val = '0' + val;
        }

        if (val.length === 2) {
            if (Number(val) === 0) {
                val = '01';

                //this can happen when user paste number
            } else if (val < min) {
                val = min;
            }
        }

        return val;
    }

    limitMonthCreditCard(val, max) {
        if (val.length === 1 && val[0] > max[0]) {
            val = '0' + val;
        }

        if (val.length === 2) {
            if (Number(val) === 0) {
                val = '01';

                //this can happen when user paste number
            } else if (val > max) {
                val = max;
            }
        }

        return val;
    }

    cardExpiry(val) {
        let month = this.limitMonthCreditCard(val.substring(0, 2), '12');
        let date = this.limitYearCreditCard(val.substring(2, 4), currentTime.getFullYear().toString().substring(2, 4));
        let cardExpirydate = month + (date.length ? '/' + date : '');
        return cardExpirydate;

        //let month = this.limit(val.substring(0, 2), '12');
        //let year = val.substring(2, 4);
        //return month + (year.length ? '/' + year : '');
    }

    render() {
        const quoteStatus = this.state.tripDetails != null ? this.state.tripDetails.tripStatus : "";
        const quoteStatusId = this.state.tripDetails != null ? this.state.tripDetails.tripStatusId : 315;
        const confirmationNo = this.state.tripDetails != null ? this.state.tripDetails.confirmationNo : 0;

        return (
            <div className="forgot-password-page">
                <div>
                    <div className="forgot-password-logo">
                        <a href="#"><img src="../../dist/img/logo_utwiz.png" alt="UTWiz" /></a>
                    </div>
                    <div className="card">
                        <div className="card-body login-card-body">
                            <h4 className="text-center"><strong>Quotation Number - <span className="text-info">{this.state.quoteId}</span></strong></h4>
                            <hr />
                            <form method="post" onSubmit={this.handleConfirmQuotation} style={this.state.isSubmited ? { pointerEvents: "none", opacity: "0.4" } : {}}>
                                {quoteStatusId == 317 && <div>
                                    <span className="text-info">Your quote is already <b>Cancelled</b></span><hr />
                                </div>}
                                {quoteStatusId == 318 && <div>
                                    <span className="text-info">Your quote is already <b>Confirmed</b></span>. Your confirmation# {confirmationNo}.<hr />
                                </div>}
                                <div className="row">
                                    <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                        <div className="form-group">
                                            <label>Pax First Name</label>
                                            <div><strong>{this.state.paxFirstName} {this.state.paxLastName}</strong></div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                        <div className="form-group">
                                            <label>Email</label>
                                            <div><strong>{this.state.email}</strong></div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                        <div className="form-group">
                                            <label>Pax Phone Number</label>
                                            <div><strong>+{this.state.cellCountryCode} {this.state.mobileNo}</strong></div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                        <div className="form-group">
                                            <label>Pick-up Date Time</label>
                                            <div><strong>{this.state.puDateTime}</strong></div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                        <div className="form-group">
                                            <label>Vehicle Type</label>
                                            <div><strong>{this.state.vehicleType}</strong></div>
                                        </div>
                                    </div>
                                    <div className="col-lg-2 col-md-4 col-sm-2 col-xs-2">
                                        <div className="form-group">
                                            <label>Pax Count</label>
                                            <div><strong>{this.state.noOfPax}</strong></div>
                                        </div>
                                    </div>
                                    <div className="col-lg-2 col-md-4 col-sm-2 col-xs-2">
                                        <div className="form-group">
                                            <label>Total Fare</label>
                                            <div><strong className="text-success">${this.state.totalFare}</strong></div>
                                        </div>
                                    </div>
                                </div>
                                <hr />
                                <div className="row">
                                    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                        <div className="form-group">
                                            <label>Pick-up Location</label>
                                            <div><strong>{this.state.pickupLocation}</strong></div>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                        <div className="form-group">
                                            <label>Pick-up Address</label>
                                            <div><strong>{this.state.pickupAddress}</strong></div>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                        <div className="form-group">
                                            <label>Drop Off Location</label>
                                            <div><strong>{this.state.dropoffLocation}</strong></div>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                        <div className="form-group">
                                            <label>Drop Off Address</label>
                                            <div><strong>{this.state.dropoffAddress}</strong></div>
                                        </div>
                                    </div>
                                </div>
                                <hr />
                                <div className="row">
                                    <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                                        <div className="form-group">
                                            <label>Payment Method</label>
                                            <SelectBox
                                                dataSource={this.state.dropdownPaymentType.length > 0 ? this.state.dropdownPaymentType : []}
                                                className="basic-multi-select"
                                                classNamePrefix="select"
                                                placeholder="Select payment type"
                                                name="paymentTypeId"
                                                defaultValue={0}
                                                value={this.state.paymentTypeId}
                                                displayExpr='name'
                                                valueExpr='id'
                                                onSelectionChanged={this.handlePaymentTypeChange}
                                                showClearButton={false}
                                                disabled={true}
                                                searchEnabled={true}
                                            />
                                            {this.state.errors["paymentTypeId"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["paymentTypeId"]}</span>}
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                                        <div className="form-group">
                                            <label>Payment Terms</label>
                                            <select className="form-control form-control-sm" name="paymentTermId" value={this.state.paymentTermId} disabled={this.state.totalFare <= 0} onChange={this.handleInputChange}>
                                                <option value="1">Paid In Full</option>
                                                <option value="2">Paid In Partial</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                                        <div className="form-group">
                                            <label>Total Paid Amount</label>
                                            <NumberFormat className="form-control form-control-sm" name="paidAmount" disabled={(parseInt(this.state.paymentTermId) === 1)} fixedDecimalScale={true} maxLength={12} prefix={'$'} decimalScale={3} title="Paid Amount" value={this.state.paidAmount} onValueChange={(values) => { this.setState({ paidAmount: values.floatValue }) }} placeholder="Enter total paid amount" />
                                            {this.state.errors["paidAmount"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["paidAmount"]}</span>}
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3" style={{ display: this.state.paymentTypeId == 2 ? 'flex' : 'none' }}>
                                        <div className="form-group">
                                            <label htmlFor="">Payment Gateway</label><br />
                                            <span className="form-check">
                                                <input className="form-check-input" type="radio" name="rdPayUMoney" value="1" disabled={this.state.paymentTypeId != 2} checked={this.state.chkPaymentGatewaySelection === "1"} onChange={this.handlePaymentGatewaySelectionChange} />
                                                <label className="form-check-label">PayUMoney</label>
                                            </span>
                                            <span className="form-check">
                                                <input className="form-check-input" type="radio" name="rdBraintree" value="2" disabled={this.state.paymentTypeId != 2} checked={this.state.chkPaymentGatewaySelection === "2"} onChange={this.handlePaymentGatewaySelectionChange} />
                                                <label className="form-check-label">Braintree</label>
                                            </span>

                                        </div>
                                    </div>
                                </div>
                                <div className="row" style={{ display: (this.state.paymentTypeId == 2 || this.state.paymentTypeId == 4 || this.state.paymentTypeId == 7) ? 'flex' : 'none' }}>
                                    <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3" style={{ display: this.state.paymentTypeId !== 4 ? 'none' : 'inline-block' }}>
                                        <div className="form-group">
                                            <label>Check Number</label>
                                            <input type="text" className="form-control form-control-sm" name="checkNumber" disabled={this.state.paymentTypeId !== 4} placeholder="Enter check number" maxLength="12" title="Check Number" value={this.state.checkNumber} onChange={this.handleInputChange} />
                                            {this.state.errors["checkNumber"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["checkNumber"]}</span>}
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3" style={{ display: this.state.paymentTypeId !== 4 ? 'none' : 'inline-block' }}>
                                        <div className="form-group">
                                            <label>Check Date</label>
                                            <DatePicker
                                                className="form-control form-control-sm "
                                                placeholderText="Select check date"
                                                name="checkDate"
                                                selected={this.state.checkDate}
                                                dateFormat="MM/dd/yyyy"
                                                onChange={date => this.setState({ checkDate: date })}
                                                disabled={this.state.paymentTypeId !== 4}
                                            />
                                            {this.state.errors["checkDate"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["checkDate"]}</span>}
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6" style={{ display: this.state.paymentTypeId !== 4 ? 'none' : 'inline-block' }}>
                                        <div className="form-group">
                                            <label>Bank Name</label>
                                            <input type="text" className="form-control form-control-sm" disabled={this.state.paymentTypeId !== 4} name="checkBank" placeholder="Enter bank name" maxLength="50" title="Bank Name" value={this.state.checkBank} onChange={this.handleInputChange} />
                                            {this.state.errors["checkBank"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["checkBank"]}</span>}
                                        </div>
                                    </div>

                                    <div className="col-lg-7 col-md-7 col-sm-7 col-xs-7" style={{ display: (this.state.chkPaymentGatewaySelection === "1" || this.state.paymentTypeId !== 2) ? 'none' : 'inline-block' }}>
                                        <div className="form-group">
                                            <label>Card Number</label>
                                            <div className="input-group mb-3">
                                                <NumberFormat className="form-control form-control-sm" isNumericString={false} name="creditCard" placeholder="Enter credit card number" format="#### #### #### ####" disabled={this.state.paymentTypeId !== 2} value={this.state.creditCard} onChange={this.handleInputChange} />
                                                <div className="input-group-append">
                                                    <div className="input-group-text">
                                                        <img src={this.state.cardImage} width="20" />
                                                    </div>
                                                </div>
                                            </div>
                                            {this.state.errors["creditCard"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["creditCard"]}</span>}
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3" style={{ display: (this.state.chkPaymentGatewaySelection === "1" || this.state.paymentTypeId !== 2) ? 'none' : 'inline-block' }}>
                                        <div className="form-group">
                                            <label>Card Type</label>
                                            <select name="cardType" className="form-control form-control-sm" value={this.state.cardType} disabled={this.state.paymentTypeId !== 2} onChange={this.handleInputChange}>
                                                <option value="0">Select card type</option>
                                                {
                                                    CardTypes &&
                                                    CardTypes.map((item, i) =>
                                                        (<option key={i} value={item.name}>{item.name}</option>))
                                                }
                                            </select>
                                            {this.state.errors["cardType"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["cardType"]}</span>}
                                        </div>
                                    </div>
                                    <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2" style={{ display: (this.state.chkPaymentGatewaySelection === "1" || this.state.paymentTypeId !== 2) ? 'none' : 'inline-block' }}>
                                        <div className="form-group">
                                            <label>Card Expiry</label>
                                            <NumberFormat className="form-control form-control-sm" name="cardExpiry" disabled={this.state.paymentTypeId !== 2} placeholder="MM/YY" format={this.cardExpiry} title="Credit Card Expiry" value={this.state.cardExpiry} onValueChange={(values) => { const { formattedValue, value } = values; this.setState({ cardExpiry: formattedValue }) }} />
                                            {this.state.errors["cardExpiry"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["cardExpiry"]}</span>}
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4" style={{ display: this.state.paymentTypeId !== 7 ? 'none' : 'inline-block' }}>
                                        <div className="form-group">
                                            <label>Company</label>
                                            <SelectBox
                                                dataSource={this.state.dropdownVoucherCompany.length > 0 ? this.state.dropdownVoucherCompany : []}
                                                className="basic-multi-select"
                                                classNamePrefix="select"
                                                placeholder="Select company"
                                                name="voucherCompanyId"
                                                defaultValue={0}
                                                value={this.state.voucherCompanyId}
                                                displayExpr='name'
                                                valueExpr='id'
                                                onSelectionChanged={this.handleVoucherCompanyChange}
                                                showClearButton={true}
                                                disabled={this.state.paymentTypeId !== 7}
                                                searchEnabled={true}
                                            />
                                            {this.state.errors["voucherCompanyId"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["voucherCompanyId"]}</span>}
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3" style={{ display: this.state.paymentTypeId !== 7 ? 'none' : 'inline-block' }}  >
                                        <div className="form-group">
                                            <label>Voucher</label>
                                            <input type="text" className="form-control form-control-sm" name="voucherCode" disabled={this.state.paymentTypeId !== 7} placeholder="Enter Voucher Code" maxLength="50" title="Voucher Code" value={this.state.voucherCode} onChange={this.handleInputChange} />
                                            {this.state.errors["voucherCode"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["voucherCode"]}</span>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 mt-3 text-left">
                                        <NavLink tag={Link} to="/"><i className="mb-0 text-center"></i>Go back to UTWiz login</NavLink>
                                    </div>
                                    {quoteStatusId == 316 && <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 mt-3 text-right">
                                        <button type="submit" className="btn btn-success btn-sm" onClick={this.handleConfirmQuotation} >
                                            {this.state.isSubmited && <span className="In-process"><i className="fas fa-spinner fa-spin"></i> In-process</span>}
                                            {!this.state.isSubmited && <span className="Confirm"><i className="fas fa-check"></i> Confirm</span>}
                                        </button>
                                    </div>}
                                </div>

                                <LoadPanel
                                    shadingColor="rgba(0,0,0,0.4)"
                                    position={position}
                                    visible={this.state.loadPanelVisible}
                                    showIndicator={true}
                                    shading={true}
                                    showPane={true}
                                    closeOnOutsideClick={false}
                                />
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}